module.exports = __webpack_public_path__ + "static/img/2_IMG_20150823_115723.59d8b1cf.jpg";